import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrServiceInt } from '../../shared/util/toastr.service';
import { Router } from '@angular/router';
import { Faculty } from '../../shared/models/faculty';
import { NewsCategoriesV2Service } from '../../../_generated/hka-app-service/api/newsCategoriesV2.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-createnewscategory',
  templateUrl: './createnewscategory.component.html',
  styleUrls: ['./createnewscategory.component.scss']
})
export class CreatenewscategoryComponent implements OnInit {
  form: FormGroup;
  bildBase64textString = '';
  angelegt = true;

  constructor(
    private fb: FormBuilder,
    private newsService: NewsCategoriesV2Service,
    private toastrService: ToastrServiceInt,
    private router: Router,
    private dialog: ConfirmationDialogService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      categoryName: ['', [Validators.required, Validators.minLength(2)]],
      feedUrl: ['', [Validators.required]],
      facultyInput: [''],
      feedFormat: ['', Validators.required],
      fileSelect: [null]
    });
  }

  createNewsCategory(): void {
    if (this.form.invalid || this.bildBase64textString === '') return;

    const value = this.form.value;

    let faculty: Faculty = null;
    if (value.facultyInput?.trim()) {
      faculty = { id: value.facultyInput } as Faculty;
    }

    this.newsService
      .createNewsCategory({
        facultyId: faculty?.id || null,
        feed: value.feedUrl,
        format: value.feedFormat,
        image: this.bildBase64textString,
        name: value.categoryName
      })
      .subscribe(
        () => {
          this.angelegt = true;
          this.toastrService.setToastrSuccess('Erfolgreich!', 'News Category erfolgreich angelegt!', {
            progressBar: true
          });
          setTimeout(() => {
            this.router.navigate(['/newscategory']);
          }, 2000);
        },
        (error) => {
          console.error(error);
          this.angelegt = false;
          this.toastrService.setToastrError('Fehlgeschlagen!', 'Ein Fehler ist aufgetreten!');
        }
      );
  }

  handleFileSelect(evt: Event): void {
    const file = (evt.target as HTMLInputElement).files?.[0];
    if (!file) {
      this.bildBase64textString = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(file);
  }

  _handleReaderLoaded(readerEvt: ProgressEvent<FileReader>) {
    const binaryString = readerEvt.target?.result as string;
    this.bildBase64textString = btoa(binaryString);
  }

  askForConfirmation(): void {
    this.dialog
      .askForConfirmation({
        message: 'Möchten Sie die Ansicht wirklich verlassen? Es könnten Änderungen verloren gehen.',
        dialogOptions: ['CANCEL', 'CONFIRM']
      })
      .pipe(filter((result) => result === 'CONFIRM'))
      .subscribe(() => this.router.navigate(['/newscategory']));
  }
}
